import { Link } from "react-router-dom";
import SEO from "@/components/SEO";

export default function NotFound() {
  return (
    <>
      <SEO title="Sayfa Bulunamadı" description="Aradığınız sayfa bulunamadı." path="/404" />
      <section className="min-h-[80vh] flex items-center justify-center px-6 pt-24 bg-[#F5F7FA]">
        <div className="text-center">
          <p className="chip mb-4 mx-auto">404</p>
          <h1 className="font-display text-5xl md:text-7xl text-[#0B1B33] mb-6 tracking-tight">Sayfa Bulunamadı</h1>
          <p className="text-[#4B5A6E] max-w-lg mx-auto mb-8">Aradığınız sayfa taşınmış veya kaldırılmış olabilir. Anasayfaya dönerek keşfetmeye devam edebilirsiniz.</p>
          <Link to="/" data-testid="404-home" className="btn-primary">Anasayfa</Link>
        </div>
      </section>
    </>
  );
}
